import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0974c3bc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/test-e-youhuo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0974c3bc')) {
      api.createRecord('0974c3bc', component.options)
    } else {
      api.reload('0974c3bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0974c3bc&", function () {
      api.rerender('0974c3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/sidebar/index.vue"
export default component.exports